import SingleChoiceButtons from 'components/DesignSystem/SingleChoiceButtons/SingleChoiceButtons';
import { ReactSelectValue } from 'types/forms';

interface MethodologyAndFieldworkProps {
  methodologyComplexity: string;
  methodologyComplexityOptions: ReactSelectValue<string>[] | undefined;
  setMethodologyComplexity: (arg: string) => void;
  methodologyFieldworkGroups: string;
  metholologyFieldworkGroupsOptions: ReactSelectValue<string>[] | undefined;
  setMethodologyFieldworkGroups: (arg: string) => void;
}

const MethodologyAndFieldwork = ({
  methodologyComplexity,
  methodologyComplexityOptions,
  setMethodologyComplexity,
  methodologyFieldworkGroups,
  metholologyFieldworkGroupsOptions,
  setMethodologyFieldworkGroups,
}: MethodologyAndFieldworkProps) => {
  return (
    <div>
      <p className="font-bold text-xl">Methodology & Fieldwork</p>
      <p className="text-sm mt-5 mb-2">Methodology Complexity:</p>
      <SingleChoiceButtons
        onSelect={setMethodologyComplexity}
        options={methodologyComplexityOptions}
        selected={methodologyComplexity}
      />
      <p className="text-sm mt-5 mb-2">
        Fieldwork: # of Sample Groups to Setup/Monitor:
      </p>
      <SingleChoiceButtons
        onSelect={setMethodologyFieldworkGroups}
        options={metholologyFieldworkGroupsOptions}
        selected={methodologyFieldworkGroups}
      />
    </div>
  );
};

export default MethodologyAndFieldwork;
